import { query } from "../../defaults/fetch";
import {useState,useEffect} from "react";


export const useGetMemoScope = ()=>{
    const [scopes,setScopes] = useState([]);


    useEffect(()=>{
        const getMemoScope = async()=>{
            const url = `system/get-offices-scopes`;
            const {data} = await query(url);
            setScopes(data);
        }
        getMemoScope();
    },[])

    return scopes;
}
